import { GcliRateGroup } from "../features/actuarial/rates-state";

export const ratesFormat66To80GYRTAndGPA = (data: GcliRateGroup[], bandKey: string) => {
    const result: Record<string, any> = {
        [bandKey]: {
            basic_plan_id: null,
        },
    };

    data.forEach((group) => {
        const ageKey = `age_${group.title}`;

        const plan = group.data.find((d: any) => d.type === "plan");

        const riders = group.data
            .filter((d: any) => d.type === "rider")
            .map((r: any) => ({
                rider_id: r.rider_id,
                rider_rate: r.amount || "0",
            }));

        if (!result[bandKey].basic_plan_id) {
            result[bandKey].basic_plan_id = plan?.plan_id ?? null;
        }

        result[bandKey][ageKey] = [
            {
                basic_rate: plan?.amount || "0",
                riders,
            },
        ];
    });

    return result;
}